import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholders by Impact and Influence',
      type: 'table',
      alias: 'stakeholders-by-impact-and-influence',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'records',
                },
              },
              subqueries: {
                records: {
                  target: 'ent:!stakeholders:!stakeholder',
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!name',
                },
              },
              target: 'ent:!stakeholders:!stakeholder',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      department: {
                        '{}': {
                          value: {
                            '@': 'department',
                          },
                        },
                      },
                      projectRole: {
                        '{}': {
                          value: {
                            '@.': '!project_role',
                          },
                        },
                      },
                      projectTeam: {
                        '{}': {
                          value: {
                            '@.': '!is_project_team_member',
                          },
                        },
                      },
                      changeChampion: {
                        '{}': {
                          value: {
                            '@.': '!change_champion',
                          },
                        },
                      },
                      degreeOfImpact: {
                        '{}': {
                          color: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!degree_of_impact',
                                    },
                                    'High',
                                  ],
                                },
                                '#3AA69B',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!degree_of_impact',
                                    },
                                    'Medium',
                                  ],
                                },
                                '#FBC02D',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!degree_of_impact',
                                    },
                                    'Low',
                                  ],
                                },
                                '#CD4643',
                              ],
                              null,
                            ],
                          },
                          value: {
                            '@.': '!degree_of_impact',
                          },
                        },
                      },
                      stakeholderName: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      engagementNeeded: {
                        '{}': {
                          value: {
                            '@.': '!engagement_needed',
                          },
                        },
                      },
                      influenceDecisionRole: {
                        '{}': {
                          color: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!influence_decision_role',
                                    },
                                    'High',
                                  ],
                                },
                                '#3AA69B',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!influence_decision_role',
                                    },
                                    'Medium',
                                  ],
                                },
                                '#FBC02D',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!influence_decision_role',
                                    },
                                    'Low',
                                  ],
                                },
                                '#CD4643',
                              ],
                              null,
                            ],
                          },
                          value: {
                            '@.': '!influence_decision_role',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                employee: {
                  ref: {
                    attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
                  },
                  target: 'ent:!personnel:!employee',
                },
                department: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!org',
                  },
                  using: 'employee',
                  target: 'ent:!org:!subdept',
                  quantity: 1,
                  selection: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-advancement',
                          ],
                        },
                        'Advancement',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-athletics',
                          ],
                        },
                        'Athletics',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-finance-and-treasury',
                          ],
                        },
                        'Finance and Treasury',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-information-technology',
                          ],
                        },
                        'Information Technology',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-undergraduate-financial-aid',
                          ],
                        },
                        'Undergraduate Financial Aid',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-school-of-engineering-and-applied-science',
                          ],
                        },
                        'School of Engineering and Applied Science',
                      ],
                      null,
                    ],
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'stakeholderName',
                  direct: {
                    '{}': {
                      name: 'Stakeholder',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'department',
                  direct: {
                    '{}': {
                      name: 'Department / Function',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'projectRole',
                  direct: {
                    '{}': {
                      name: 'Project Role',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_project_role',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'projectTeam',
                  direct: {
                    '{}': {
                      name: 'Project Team',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'degreeOfImpact',
                  direct: {
                    '{}': {
                      name: 'Impact',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'influenceDecisionRole',
                  direct: {
                    '{}': {
                      name: 'Influence',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'changeChampion',
                  direct: {
                    '{}': {
                      name: 'Change Champion',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_change_champion',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'engagementNeeded',
                  direct: {
                    '{}': {
                      name: 'Engagement Needed',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_engagement_needed',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
